import LAYOUT from '@/layout/layout';

export default [
	{
		path: '/api-docs',
		name: 'ApiDocs',
		component: () => import('@/components/Modules/Menus/ApiDocs.vue'),
	},
	{
		path: '/product-roadmap',
		name: 'ApiDocs',
		component: () => import('@/components/Modules/Menus/ProductRoadmap.vue'),
	},
];
